import { WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';

const _axios = HttpService.getAxiosClient();

const run = async (call) => {
  try {
    return ErrorSwitchCase(await call());
  } catch (error) {
    return ErrorSwitchCase(error.response?.data || error.response);
  }
};

export const createWeekendRequest = (payload) =>
  run(() => _axios.post(`${WORKFLOW_PATH}/weekend-working/`, payload));

export const getMyWeekendRequests = (
  employeeId,
  { status, pageNumber = 0, pageSize = 5 } = {},
) =>
  run(() =>
    _axios.get(`${WORKFLOW_PATH}/weekend-working/users/${employeeId}`, {
      params: { pageNumber, pageSize, ...(status ? { status } : {}) },
    }),
  );

export const getWeekendRequestsToDecide = ({
  status,
  pageNumber = 0,
  pageSize = 5,
} = {}) =>
  run(() =>
    _axios.get(`${WORKFLOW_PATH}/weekend-working/manager/me`, {
      params: { pageNumber, pageSize, ...(status ? { status } : {}) },
    }),
  );

export const decideWeekendRequest = (requestId, status, comment) =>
  run(() =>
    _axios.put(`${WORKFLOW_PATH}/weekend-working/${requestId}/decision`, {
      status,
      comment,
    }),
  );

export const getApprovedWeekendDates = (employeeId, from, to) =>
  run(() =>
    _axios.get(
      `${WORKFLOW_PATH}/weekend-working/users/${employeeId}/approved-dates`,
      { params: { from, to } },
    ),
  );

export const createWeekendTask = (payload) =>
  run(() => _axios.post(`${WORKFLOW_PATH}/weekend-working/tasks`, payload));

export const getMyWeekendTasks = (
  employeeId,
  { status, pageNumber = 0, pageSize = 200 } = {},
) =>
  run(() =>
    _axios.get(`${WORKFLOW_PATH}/weekend-working/tasks/users/${employeeId}`, {
      params: { pageNumber, pageSize, ...(status ? { status } : {}) },
    }),
  );

export const getWeekendTasksToDecide = ({
  status,
  pageNumber = 0,
  pageSize = 5,
} = {}) =>
  run(() =>
    _axios.get(`${WORKFLOW_PATH}/weekend-working/tasks/manager/me`, {
      params: { pageNumber, pageSize, ...(status ? { status } : {}) },
    }),
  );

export const decideWeekendTask = (taskId, status, comment) =>
  run(() =>
    _axios.put(`${WORKFLOW_PATH}/weekend-working/tasks/${taskId}/decision`, {
      status,
      comment,
    }),
  );

export const deleteWeekendTask = (taskId) =>
  run(() => _axios.delete(`${WORKFLOW_PATH}/weekend-working/tasks/${taskId}`));
